import BaseView from '../../../js/base-view';

const CLASS_BIG_TOP_MARGIN = 'artist-header--big-top-margin';
const THRESHOLD_BIG_MARGIN = 3;

export default class ArtistHeader extends BaseView {
	init() {
		this.titleEl = this.el.querySelector('.artist-header__title');
		this.checkTitleNbLines();
		this.on('resize', this.checkTitleNbLines.bind(this));
	}

	checkTitleNbLines() {
		if (!this.titleEl) return;
		const titleHeight = this.titleEl.offsetHeight;
		const titleStyles = window.getComputedStyle(this.titleEl);
		const nbLines = parseInt(titleHeight) / parseInt(titleStyles.lineHeight);
		this.el.classList[nbLines < THRESHOLD_BIG_MARGIN ? 'add' : 'remove'](CLASS_BIG_TOP_MARGIN);
	}
}